import { SET_TELEPHONE } from "../actionTypes";

const initialState = "";

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_TELEPHONE: {
      return action.payload;
    }
    default:
      return state;
  }
};
